import { render, staticRenderFns } from "./IletisimTuruPicker.vue?vue&type=template&id=1ac6c4b8"
import script from "./IletisimTuruPicker.vue?vue&type=script&lang=ts"
export * from "./IletisimTuruPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports